import { get } from '../../helpers/api';

// HITCH-5504 exposes driver quest claims (active/completed/canceled) as a
// read-only, cursor-paginated admin resource — same shape as rider-driver
// exclusions' sibling endpoint.
const BASE = '/admin/driver-quests/claims';

const DEFAULT_LIMIT = 50;
const MAX_LIMIT = 100;

// Wire params are `search` and `questId` (filtering by a specific quest, not a
// quest type) per the merged HITCH-5504 DTO — not the `searchQuery`/
// `questTypeId` names the pre-merge plan assumed.
// `driverMongoId` is an exact match on one driver (the user page's id), unlike
// `search`'s substring match on name/email/phone.
const getClaims = async ({ status, questId, driverMongoId, searchQuery, cursor, limit } = {}) => {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  if (questId) params.set('questId', questId);
  if (driverMongoId) params.set('driverMongoId', driverMongoId);
  const search = (searchQuery || '').trim();
  if (search) params.set('search', search);
  if (cursor) params.set('cursor', cursor);
  // Clamp client-side to the server's max rather than trusting callers not to
  // pass an unbounded limit.
  params.set('limit', String(Math.min(limit ?? DEFAULT_LIMIT, MAX_LIMIT)));

  const { data } = await get(`${BASE}?${params.toString()}`);
  return { entries: data?.entries ?? [], nextCursor: data?.nextCursor ?? null };
};

export default { getClaims };
